import request from '@/utils/request';

/**
 * 查询客户管理导航栏设置接口
 * @param {*} data
 */
// export function configHeaderModelSortAPI(data) {
//   return request({
//     url: 'adminConfig/queryHeaderModelSort',
//     method: 'post',
//     data: data
//   })
// }

/**
 * 修改首页顶部导航栏设置接口
 * @param {*} data
 */
export function configSetHeaderModelSortAPI(data) {
  return request({
    url: 'adminConfig/setHeaderModelSort',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// /**
//  * 查询咨询活动
//  * @param {*} data
//  */
// export function configQueryMarketingAPI(data) {
//   return request({
//     url: 'adminConfig/queryMarketing',
//     method: 'post',
//     data: data
//   })
// }

/**
 * 设置咨询活动
 * @param {*} data
 */
export function configSetMarketingAPI(data) {
  return request({
    url: 'adminConfig/setMarketing',
    method: 'post',
    data: data
  });
}

/**
 * 是否绑定企业微信
 * @param {*} data
 * https://yapi.lanhanba.com/project/333/interface/api/34065
 */
export function adminUserHasBindWx(data) {
  return request({
    url: 'adminUser/isBindWx',
    method: 'get',
    params: data
  });
}

/**
 * 获取oauth地址
 * @param {*} data
 * https://yapi.lanhanba.com/project/333/interface/api/34064
 */
export function adminUserGetOauthUrl(data) {
  return request({
    url: 'adminUser/getOauthUrl',
    method: 'get',
    params: data
  });
}

/**
 * oauth回调
 * @param {*} data
 * https://yapi.lanhanba.com/project/333/interface/api/34088
 */
export function adminUserOauthNotify(data) {
  return request({
    url: 'adminUser/oauthNotify',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 解绑企业微信
 * @param {*} data
 * https://yapi.lanhanba.com/project/333/interface/api/34161
 */
export function adminUserUnbindWx(data) {
  return request({
    url: 'adminUser/unbindWx',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
